import { render, staticRenderFns } from "./AcceptableTask.vue?vue&type=template&id=0c2dc26e&scoped=true&"
import script from "./AcceptableTask.vue?vue&type=script&lang=js&"
export * from "./AcceptableTask.vue?vue&type=script&lang=js&"
import style0 from "./AcceptableTask.vue?vue&type=style&index=0&id=0c2dc26e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2dc26e",
  null
  
)

export default component.exports